import { render, staticRenderFns } from "./BrandShopCart.vue?vue&type=template&id=45428cae&scoped=true"
import script from "./BrandShopCart.vue?vue&type=script&lang=js"
export * from "./BrandShopCart.vue?vue&type=script&lang=js"
import style0 from "./BrandShopCart.vue?vue&type=style&index=0&id=45428cae&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45428cae",
  null
  
)

export default component.exports